import { Card } from "@/components/ui/card";
import useDocumentTitle from "@/components/ui/common/document-title";
import WalletRefundTableView from "./table";

export default function WalletRefund() {
  useDocumentTitle("Wallet Refund");
  
  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <WalletRefundTableView/>
      </Card>
    </div>
  );
}
